import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Review = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const referrer = location.search.substring(1) || "";

  const ranOnce = useRef(false); // 👈 guard
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState("idle"); // idle | success | error

  const getDetails = useCallback(async () => {
    if (ranOnce.current) return; // 🔥 STOP second call
    ranOnce.current = true;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}verify/${referrer}`
      );

      const data = await res.json();

      if (data.status === true) {
        setStatus("success");

        setTimeout(() => {
          navigate("/login", { replace: true });
        }, 3000);
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    } finally {
      setLoading(false);
    }
  }, [referrer, navigate]);

  useEffect(() => {
    getDetails();
  }, [getDetails]);

  return (
    <div className="min-h-screen text-white flex items-center justify-center text-2xl">
      {loading && <p>Verifying Account...</p>}

      {!loading && status === "success" && (
        <p className="text-green-400">
          Account Verified Successfully. Redirecting...
        </p>
      )}

      {!loading && status === "error" && (
        <p className="text-red-400">
           Oops! An error occurred. Kindly contact support.
        </p>
      )}
    </div>
  );
};

export default Review;
